/* Franchetti Bond revamp — header, cart drawer, PDP colour switching, collection filters.
   Vanilla JS, no dependencies. Works with the real Shopify AJAX cart API. */
(function () {
  'use strict';
  var FB = window.FB = window.FB || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- Money ---------- */
  FB.money = function (cents) {
    var fmt = FB.moneyFormat || '£{{amount}}';
    cents = parseInt(cents, 10) || 0;
    function f(n, d, ts, ds) { d = d == null ? 2 : d; ts = ts || ','; ds = ds || '.';
      var p = (n / 100).toFixed(d).split('.'); return p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ts) + (p[1] ? ds + p[1] : ''); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return f(cents, 0);
        case 'amount_with_comma_separator': return f(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return f(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return f(cents, 2, "'", '.');
        default: return f(cents, 2);
      }
    });
  };

  /* ---------- Toast ---------- */
  var toastT;
  FB.toast = function (msg) {
    var t = $('[data-fb-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  };

  /* ---------- Focus trap helper ---------- */
  var lastFocus = null;
  function openLayer(el, focusSel) {
    lastFocus = document.activeElement; el.hidden = false; document.documentElement.classList.add('fb-noscroll');
    setTimeout(function () { el.classList.add('is-open'); var f = focusSel ? $(focusSel, el) : null; f && f.focus({ preventScroll: true }); }, 20);
  }
  function closeLayer(el, delay) {
    el.classList.remove('is-open'); document.documentElement.classList.remove('fb-noscroll');
    setTimeout(function () { el.hidden = true; }, delay || 0);
    if (lastFocus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ================= HEADER ================= */
  function initHeader() {
    var header = $('[data-fb-header]'); if (!header) return;
    var drops = $$('[data-fb-drop]', header), openKey = null, closeT;
    function show(key) {
      clearTimeout(closeT); openKey = key;
      drops.forEach(function (d) { d.hidden = d.getAttribute('data-fb-drop') !== key; });
      $$('[data-fb-nav]', header).forEach(function (a) { var on = a.getAttribute('data-fb-nav') === key; a.classList.toggle('is-open', on); if (a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', on && !!$('[data-fb-drop="' + key + '"]', header)); });
    }
    function hideAll() { openKey = null; drops.forEach(function (d) { d.hidden = true; }); $$('[data-fb-nav]', header).forEach(function (a) { a.classList.remove('is-open'); if (a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'false'); }); }
    $$('[data-fb-nav]', header).forEach(function (a) {
      a.addEventListener('mouseenter', function () { show(a.getAttribute('data-fb-nav')); });
      a.addEventListener('focus', function () { show(a.getAttribute('data-fb-nav')); });
    });
    header.addEventListener('mouseleave', function () { closeT = setTimeout(hideAll, 120); });
    header.addEventListener('mouseenter', function () { clearTimeout(closeT); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { hideAll(); toggleMob(false); } });

    var burger = $('[data-fb-burger]', header), mob = $('[data-fb-mobile-nav]', header);
    function toggleMob(on) { if (!burger || !mob) return; on = on == null ? mob.hidden : on; mob.hidden = !on; burger.setAttribute('aria-expanded', on); }
    burger && burger.addEventListener('click', function () { toggleMob(); });
    document.addEventListener('click', function (e) { if (mob && !mob.hidden && !header.contains(e.target)) toggleMob(false); });

    // expose header height for sticky sub-bars
    function setH() { document.documentElement.style.setProperty('--fb-sticky-top', (header.classList.contains('is-static') ? 0 : header.offsetHeight) + 'px'); }
    setH(); window.addEventListener('resize', setH);
  }

  /* ================= CART ================= */
  var drawer;
  FB.cart = {
    fetch: function () { return fetch((FB.routes && FB.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); },
    add: function (id, qty) {
      return fetch((FB.routes && FB.routes.root || '/') + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty || 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    },
    change: function (line, qty) {
      return fetch((FB.routes && FB.routes.root || '/') + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty }) }).then(function (r) { return r.json(); });
    }
  };
  function updateCount(cart) {
    $$('[data-fb-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.setAttribute('data-count', cart.item_count); });
    $$('[data-fb-cart-open]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items'); });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200); }
  function renderCart(cart, addedTitle) {
    updateCount(cart);
    if (!drawer) return;
    var lines = $('[data-fb-lines]', drawer), empty = $('[data-fb-empty]', drawer);
    empty.hidden = cart.item_count > 0;
    lines.innerHTML = cart.items.map(function (it, i) {
      var title = it.product_title, sub = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      var parts = title.split(' '); var head = parts.shift(); var rest = parts.join(' ');
      var compare = it.original_line_price > it.final_line_price ? '<s>' + FB.money(it.original_line_price) + '</s>' : '';
      return '<div class="fb-line">' +
        (it.image ? '<img class="fb-line__img" src="' + esc(img(it.image, 200)) + '" alt="' + esc(title) + '" width="88" height="88" loading="lazy">' : '<span class="fb-line__img"></span>') +
        '<div class="fb-line__main"><div class="fb-line__top"><a class="fb-line__title" href="' + esc(it.url) + '">' + esc(head) + '</a><span class="fb-line__price">' + FB.money(it.final_line_price) + compare + '</span></div>' +
        '<span class="fb-line__sub">' + esc(rest + (sub ? ' · ' + sub : '')) + '</span>' +
        '<div class="fb-line__row"><div class="fb-qty" role="group" aria-label="Quantity for ' + esc(title) + '">' +
        '<button type="button" aria-label="Decrease quantity" data-fb-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 12h14"/></svg></button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" aria-label="Increase quantity" data-fb-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 12h14M12 5v14"/></svg></button></div>' +
        '<button type="button" class="fb-line__remove" data-fb-line="' + (i + 1) + '" data-q="0">Remove</button></div></div></div>';
    }).join('');
    var sub = $('[data-fb-subtotal]', drawer); if (sub) sub.textContent = FB.money(cart.total_price);
    var chk = $('[data-fb-checkout]', drawer); if (chk) chk.disabled = cart.item_count === 0;
    // free delivery progress
    var th = parseInt(drawer.getAttribute('data-threshold'), 10) || 0, msg = $('[data-fb-ship-msg]', drawer), bar = $('[data-fb-ship-bar]', drawer);
    if (th && msg) {
      var left = th - cart.total_price;
      msg.textContent = left <= 0 ? drawer.getAttribute('data-msg-done') : drawer.getAttribute('data-msg-away').replace('[amount]', FB.money(left));
      bar.style.width = Math.min(100, cart.total_price / th * 100) + '%';
      bar.parentNode.setAttribute('aria-valuenow', Math.min(th, cart.total_price));
    }
    var added = $('[data-fb-added]', drawer);
    if (added) { added.hidden = !addedTitle; if (addedTitle) added.textContent = 'Added: ' + addedTitle; }
    // upsells: hide products already in the cart
    var inCart = cart.items.map(function (i) { return String(i.product_id); });
    var ups = $$('[data-fb-up]', drawer), shown = 0;
    ups.forEach(function (u) { var hide = inCart.indexOf(u.getAttribute('data-product-id')) > -1 || shown >= 3; u.hidden = hide; if (!hide) shown++; });
    var upsWrap = $('[data-fb-ups]', drawer); if (upsWrap) upsWrap.hidden = !(cart.item_count > 0 && shown > 0);
  }
  FB.openCart = function (addedTitle) {
    if (!drawer || FB.cartDrawer === false) { location.href = (FB.routes && FB.routes.cart) || '/cart'; return; }
    FB.cart.fetch().then(function (c) { renderCart(c, addedTitle); });
    openLayer(drawer, '[data-fb-drawer-close].fb-icon-btn');
  };
  FB.addToCart = function (id, qty, label, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    return FB.cart.add(id, qty).then(function () {
      if (FB.cartDrawer === false || !drawer) { FB.cart.fetch().then(updateCount); FB.toast('Added to cart' + (label ? ': ' + label : '')); return; }
      FB.openCart(label);
    }).catch(function (err) {
      FB.toast((err && (err.description || err.message)) || 'Sorry, that could not be added.');
      throw err;
    }).finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  };
  function initCart() {
    drawer = $('[data-fb-drawer]');
    $$('[data-fb-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { if (!drawer || FB.cartDrawer === false) return; e.preventDefault(); FB.openCart(); }); });
    if (drawer) {
      $$('[data-fb-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { closeLayer(drawer, 260); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeLayer(drawer, 260); });
      drawer.addEventListener('click', function (e) {
        var b = e.target.closest('[data-fb-line]'); if (!b) return;
        b.disabled = true;
        FB.cart.change(parseInt(b.getAttribute('data-fb-line'), 10), Math.max(0, Math.min(99, parseInt(b.getAttribute('data-q'), 10)))).then(function (c) { renderCart(c); });
      });
    }
    if (FB._cartBound) return; FB._cartBound = true;
    // Any [data-fb-add] button anywhere (cards, carousels, upsells)
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fb-add]'); if (!b) return;
      e.preventDefault();
      FB.addToCart(b.getAttribute('data-fb-add'), 1, b.getAttribute('data-fb-add-label') || '', b).catch(function () {});
    });
    // keep the count in sync when legacy theme code changes the cart
    if (window.fetch && !window.__fbFetchHooked) {
      window.__fbFetchHooked = true;
      var of = window.fetch;
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        return of.apply(this, arguments).then(function (r) {
          if (/\/cart\/(add|change|update|clear)/.test(url) && !/fb=1/.test(url)) setTimeout(function () { FB.cart.fetch().then(updateCount); }, 50);
          return r;
        });
      };
    }
  }

  /* ================= GENERIC: accordions, carousels, scroll-to ================= */
  function initGeneric() {
    if (!FB._genBound) document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-fb-acc]');
      if (a) {
        var p = document.getElementById(a.getAttribute('aria-controls')); var open = a.getAttribute('aria-expanded') !== 'true';
        a.setAttribute('aria-expanded', open); p && p.classList.toggle('is-open', open); return;
      }
      var m = e.target.closest('[data-fb-review-more]');
      if (m) { var t = m.parentNode.querySelector('[data-fb-review-text]'); var ex = m.getAttribute('aria-expanded') !== 'true';
        m.setAttribute('aria-expanded', ex); t.classList.toggle('is-clamped', !ex); m.textContent = ex ? 'Read less' : 'Read more'; return; }
      var s = e.target.closest('[data-fb-scrollto]');
      if (s) { var id = (s.getAttribute('href') || '').replace(/^#/, ''); var el = id && document.getElementById(id);
        if (el) { e.preventDefault(); window.scrollTo({ top: el.getBoundingClientRect().top + scrollY - 16, behavior: reduced ? 'auto' : 'smooth' }); } }
    });
    $$('[data-fb-carousel]').forEach(function (c) {
      var tr = $('[data-fb-car-track]', c); if (!tr) return;
      var go = function (d) { tr.scrollBy({ left: d * tr.clientWidth * 0.8, behavior: reduced ? 'auto' : 'smooth' }); };
      var p = $('[data-fb-car-prev]', c), n = $('[data-fb-car-next]', c);
      p && p.addEventListener('click', function () { go(-1); });
      n && n.addEventListener('click', function () { go(1); });
    });
    // film banner pause / play
    $$('[data-fb-film]').forEach(function (f) {
      var btn = $('[data-fb-film-toggle]', f), vid = $('[data-fb-film-video]', f), playing = !reduced;
      function set(on) { playing = on; f.classList.toggle('is-paused', !on); if (vid) { on ? vid.play().catch(function () {}) : vid.pause(); }
        $('[data-fb-film-pause]', btn).hidden = !on; $('[data-fb-film-play]', btn).hidden = on; btn.setAttribute('aria-label', on ? 'Pause film' : 'Play film'); }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (en) { f.classList.toggle('is-paused', !en.isIntersecting || !playing); }); }).observe(f);
      btn && btn.addEventListener('click', function () { set(!playing); });
      set(playing);
    });
    // favourites (per-browser)
    var favs = store.get('fbFavs', {});
    $$('[data-fb-fav]').forEach(function (b) { var h = b.getAttribute('data-fb-fav'); b.setAttribute('aria-pressed', !!favs[h]); });
    if (FB._genBound) return; FB._genBound = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fb-fav]'); if (!b) return; e.preventDefault();
      var h = b.getAttribute('data-fb-fav'); favs[h] = !favs[h]; store.set('fbFavs', favs);
      $$('[data-fb-fav="' + h + '"]').forEach(function (x) { x.setAttribute('aria-pressed', !!favs[h]); });
    });
  }

  /* ================= PDP ================= */
  function initPdp() {
    var root = $('[data-fb-pdp]'); if (!root) return;
    var colours = JSON.parse($('[data-fb-colours]', root).textContent);
    var cfg = JSON.parse($('[data-fb-pdp-config]', root).textContent);
    var cur = colours.findIndex(function (c) { return c.index === cfg.current; }); if (cur < 0) cur = 0;
    var form = $('[data-fb-product-form]', root) || $('form.fb-pdp__form', root), vInput = $('[data-fb-variant-input]', root);
    var qty = 1, qOut = $('[data-fb-qty-out]', root), qIn = $('[data-fb-qty-input]', root);
    var buyWrap = $('[data-fb-buy-wrap]', root), soldWrap = $('[data-fb-soldout-wrap]', root), errEl = $('[data-fb-error]', root);
    var atcMain = $('[data-fb-atc-main]', root), selector = $('[data-fb-selector]', root);
    var sticky = $('[data-fb-sticky]');
    var wishes = store.get('fbFavs', {});

    function c() { return colours[cur]; }
    function galset(i) { return $('[data-fb-galset="' + i + '"]', root); }

    /* gallery */
    function buildThumbs(gs) {
      var th = $('[data-fb-thumbs]', gs); if (!th || th.childElementCount) return;
      $$('[data-fb-slide]', gs).forEach(function (s, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'fb-gal__thumb' + (i === 0 ? ' is-active' : ''); b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', i === 0); b.setAttribute('aria-label', (i + 1) + ': ' + (s.getAttribute('data-label') || 'Image'));
        b.innerHTML = '<img src="' + esc(s.getAttribute('data-thumb')) + '" alt="" width="76" height="76" loading="lazy">' + (s.getAttribute('data-tag') ? '<span class="fb-gal__thumb-tag">' + esc(s.getAttribute('data-tag')) + '</span>' : '');
        b.addEventListener('click', function () { goSlide(gs, i); });
        th.appendChild(b);
      });
    }
    function goSlide(gs, i) {
      var slides = $$('[data-fb-slide]', gs), n = slides.length; if (!n) return;
      i = (i + n) % n; gs._i = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      $$('.fb-gal__dots span', gs).forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      $$('.fb-gal__thumb', gs).forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', k === i); });
      var cnt = $('[data-fb-count]', gs); if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
      var at = $$('.fb-gal__thumb', gs)[i]; if (at && at.parentNode.scrollWidth > at.parentNode.clientWidth) at.parentNode.scrollTo({ left: at.offsetLeft - 20, behavior: reduced ? 'auto' : 'smooth' });
      if (lb && !lb.hidden) syncLb();
    }
    $$('[data-fb-galset]', root).forEach(function (gs) {
      gs._i = 0; buildThumbs(gs);
      var g = $('[data-fb-gal]', gs);
      var p = $('[data-fb-prev]', gs), n = $('[data-fb-next]', gs);
      p && p.addEventListener('click', function () { goSlide(gs, gs._i - 1); });
      n && n.addEventListener('click', function () { goSlide(gs, gs._i + 1); });
      g.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); goSlide(gs, gs._i + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); goSlide(gs, gs._i - 1); } });
      var tx = null;
      g.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      g.addEventListener('touchend', function (e) { if (tx == null) return; var dx = e.changedTouches[0].clientX - tx; tx = null; if (Math.abs(dx) > 40) goSlide(gs, gs._i + (dx < 0 ? 1 : -1)); });
      $$('[data-fb-slide] > button', gs).forEach(function (b) { b.addEventListener('click', openLb); });
    });

    /* lightbox */
    var lb = $('[data-fb-lb]'), lbFrame = lb && $('[data-fb-lb-frame]', lb), lbImg = lb && $('[data-fb-lb-img]', lb);
    function activeGs() { return galset(c().index); }
    function syncLb() {
      var gs = activeGs(), slides = $$('[data-fb-slide]', gs), s = slides[gs._i || 0]; if (!s) return;
      var im = $('img', s); lbImg.src = s.getAttribute('data-zoom') || (im && im.currentSrc) || ''; lbImg.alt = im ? im.alt : '';
      $('[data-fb-lb-count]', lb).textContent = ((gs._i || 0) + 1) + ' / ' + slides.length + ' · ' + c().label;
      lbFrame.classList.remove('is-zoom'); $('[data-fb-lb-hint]', lb).textContent = 'Click image to zoom';
    }
    function openLb() { if (!lb) return; syncLb(); openLayer(lb, '[data-fb-lb-close]'); }
    if (lb) {
      $('[data-fb-lb-close]', lb).addEventListener('click', function () { closeLayer(lb); });
      $('[data-fb-lb-prev]', lb).addEventListener('click', function () { var gs = activeGs(); goSlide(gs, gs._i - 1); });
      $('[data-fb-lb-next]', lb).addEventListener('click', function () { var gs = activeGs(); goSlide(gs, gs._i + 1); });
      lbFrame.addEventListener('click', function (e) {
        var r = lbFrame.getBoundingClientRect(); lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        var z = lbFrame.classList.toggle('is-zoom'); $('[data-fb-lb-hint]', lb).textContent = z ? 'Click to zoom out' : 'Click image to zoom';
      });
      lbFrame.addEventListener('mousemove', function (e) { if (!lbFrame.classList.contains('is-zoom')) return; var r = lbFrame.getBoundingClientRect(); lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLayer(lb);
        if (e.key === 'ArrowRight') { var gs = activeGs(); goSlide(gs, gs._i + 1); }
        if (e.key === 'ArrowLeft') { var g2 = activeGs(); goSlide(g2, g2._i - 1); }
      });
    }

    /* video modal */
    var modal = $('[data-fb-modal]');
    if (modal) {
      var closeM = function () { $('[data-fb-modal-media]', modal).innerHTML = ''; closeLayer(modal); };
      $$('[data-fb-modal-close]', modal).forEach(function (b) { b.addEventListener('click', closeM); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeM(); });
      $$('[data-fb-video]').forEach(function (b) {
        b.addEventListener('click', function () {
          var src = b.getAttribute('data-fb-video'), im = $('img', b), media = $('[data-fb-modal-media]', modal);
          $('[data-fb-modal-title]', modal).textContent = b.getAttribute('data-title') || '';
          $('[data-fb-modal-cap]', modal).textContent = b.getAttribute('data-caption') || '';
          media.innerHTML = src ? '<video src="' + esc(src) + '" controls autoplay playsinline' + (im ? ' poster="' + esc(im.currentSrc || im.src) + '"' : '') + '></video>'
            : (im ? '<img src="' + esc(im.currentSrc || im.src) + '" alt="' + esc(im.alt) + '">' : '');
          openLayer(modal, '[data-fb-modal-close].fb-icon-btn');
        });
      });
    }

    /* colour switching */
    function bind(name, val, attr) {
      $$('[data-fb-bind="' + name + '"]').forEach(function (el) { if (attr) { if (val) el.setAttribute(attr, val); } else el.textContent = val; });
    }
    function render(fromUser) {
      var col = c(), st = col.status;
      $$('[data-fb-galset]', root).forEach(function (gs) { gs.hidden = gs.getAttribute('data-fb-galset') !== String(col.index); });
      $$('[data-fb-swatch]', root).forEach(function (s) { var on = s.getAttribute('data-fb-swatch') === String(col.index); s.setAttribute('aria-checked', on); s.tabIndex = on ? 0 : -1; });
      bind('colour', col.label); bind('price', col.price);
      $$('[data-fb-bind="compare"]').forEach(function (el) { el.hidden = !(cfg.showCompare && col.compare); if (col.compare) el.textContent = col.compare; });
      bind('thumb', col.thumb, 'src');
      $$('[data-fb-bind="thumb"]').forEach(function (el) { el.alt = cfg.name + ' in ' + col.label; });
      bind('status', cfg.txt[st] || '');
      if (vInput) vInput.value = col.variant;
      if (buyWrap) buyWrap.hidden = st === 'sold_out';
      if (soldWrap) soldWrap.hidden = st !== 'sold_out';
      var nb = $('[data-fb-notify-body]'); if (nb) nb.value = (cfg.txt.notifyBody || '').replace('[product]', col.title);
      $$('[data-fb-atc]').forEach(function (b) { b.textContent = st === 'sold_out' ? (b.closest('[data-fb-sticky]') ? cfg.txt.choose : (cfg.txt.choose)) : cfg.txt.atc; });
      if (errEl) errEl.hidden = true;
      var w = $('[data-fb-wish]', root); if (w) w.setAttribute('aria-pressed', !!wishes[col.handle]);
      if (fromUser) {
        if (cfg.updateUrl && history.replaceState) { try { history.replaceState(history.state, '', col.url + location.search); } catch (e) {} }
        if (document.title.indexOf(colours[prev].title) > -1) document.title = document.title.replace(colours[prev].title, col.title);
      }
    }
    var prev = cur;
    function select(i, fromUser) {
      var k = colours.findIndex(function (x) { return x.index === i; }); if (k < 0 || k === cur) return;
      prev = cur; cur = k; render(fromUser);
    }
    FB.pdpSelect = function (productId) { var k = colours.find(function (x) { return String(x.id) === String(productId); }); if (k) { select(k.index, true); return true; } return false; };
    $$('[data-fb-swatch]', root).forEach(function (s) {
      s.addEventListener('click', function () { select(parseInt(s.getAttribute('data-fb-swatch'), 10), true); });
    });
    var radios = $('[role="radiogroup"]', root);
    radios && radios.addEventListener('keydown', function (e) {
      var d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key]; if (!d) return; e.preventDefault();
      var n = colours[(cur + d + colours.length) % colours.length]; select(n.index, true);
      var b = $('[data-fb-swatch="' + n.index + '"]', root); b && b.focus();
    });
    function toSelector() {
      var el = selector || root; window.scrollTo({ top: el.getBoundingClientRect().top + scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--fb-header-h'), 10) || 0) - 24, behavior: reduced ? 'auto' : 'smooth' });
      setTimeout(function () { var b = $('[role="radio"][aria-checked="true"]', root); b && b.focus({ preventScroll: true }); }, 450);
    }
    FB._toSelector = toSelector;
    if (!FB._pdpBound) { FB._pdpBound = true; document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-fb-to-selector]'); if (t) { e.preventDefault(); FB._toSelector(); return; }
      var l = e.target.closest('[data-fb-colour-link]'); if (l && FB.pdpSelect && FB.pdpSelect(l.getAttribute('data-fb-colour-link'))) { e.preventDefault(); FB._toSelector(); }
    }); }

    /* quantity */
    $$('[data-fb-qty]', root).forEach(function (b) { b.addEventListener('click', function () { qty = Math.max(1, Math.min(99, qty + parseInt(b.getAttribute('data-fb-qty'), 10))); if (qOut) qOut.textContent = qty; if (qIn) qIn.value = qty; }); });

    /* wishlist heart */
    var wb = $('[data-fb-wish]', root);
    wb && wb.addEventListener('click', function () { var h = c().handle; wishes[h] = !wishes[h]; store.set('fbFavs', wishes); wb.setAttribute('aria-pressed', !!wishes[h]); });

    /* add to cart */
    function add(btn) {
      var col = c();
      if (col.status === 'sold_out') { if (errEl) { errEl.hidden = false; errEl.textContent = col.label + ' is sold out. Choose another colour, or ask us to let you know when it returns.'; } toSelector(); return; }
      var lbl = btn.textContent; btn.textContent = cfg.txt.adding;
      FB.addToCart(col.variant, qty, cfg.name + ' in ' + col.label, btn).catch(function (err) {
        if (errEl) { errEl.hidden = false; errEl.textContent = (err && err.description) || 'Sorry, this could not be added to your cart.'; }
      }).finally(function () { btn.textContent = lbl; });
    }
    form && form.addEventListener('submit', function (e) { e.preventDefault(); add(atcMain); });
    $$('[data-fb-atc]').forEach(function (b) { b.addEventListener('click', function () { if (c().status === 'sold_out') { toSelector(); return; } add(b); }); });

    /* notify me */
    var ns = $('[data-fb-notify-start]'); ns && ns.addEventListener('click', function () { ns.hidden = true; var f = $('[data-fb-notify-form]'); f.hidden = false; var i = $('input[type=email]', f); i && i.focus(); });
    if (/contact_posted=true/.test(location.search) && soldWrap) soldWrap.hidden = false;

    /* sticky bar: slides in under the header once the product section has scrolled out of view,
       and hides again while the closing "Add to Cart" section is on screen */
    if (sticky) {
      var closing = $('[data-fb-closing]'), headH = 0;
      var measure = function () { headH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--fb-sticky-top'), 10) || 0; };
      var upd = function () {
        var past = root.getBoundingClientRect().bottom < headH, cv = false;
        if (closing) { var r = closing.getBoundingClientRect(); cv = r.top < window.innerHeight && r.bottom > 0; }
        var on = past && !cv;
        if (on !== sticky.classList.contains('is-visible')) { sticky.classList.toggle('is-visible', on); sticky.setAttribute('aria-hidden', !on); }
      };
      measure(); upd();
      window.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', function () { measure(); upd(); });
    }

    render(false);
  }

  /* ================= COLLECTION ================= */
  function initCollection() {
    var root = $('[data-fb-collection]'); if (!root) return;
    var grid = $('[data-fb-grid]', root), cards = $$('[data-fb-card]', root), banner = $('[data-fb-banner]', root);
    var after = parseInt(root.getAttribute('data-banner-after'), 10) || 8;
    var state = { style: 'all', colour: null, sort: 'featured' };
    var styleOrder = $$('[data-fb-style]', root).map(function (b) { return b.getAttribute('data-fb-style'); }).filter(function (s) { return s !== 'all'; });
    var countEl = $('[data-fb-count]', root);
    function rank(card) { var i = styleOrder.indexOf(card.getAttribute('data-style')); return (i < 0 ? 99 : i) * 1000 + parseInt(card.getAttribute('data-index'), 10); }
    function apply() {
      var list = cards.filter(function (cd) {
        return (state.style === 'all' || cd.getAttribute('data-style') === state.style) && (state.colour === null || cd.getAttribute('data-colour') === state.colour);
      });
      var by = {
        low: function (a, b) { return a.dataset.price - b.dataset.price || a.dataset.index - b.dataset.index; },
        high: function (a, b) { return b.dataset.price - a.dataset.price || a.dataset.index - b.dataset.index; },
        az: function (a, b) { return a.dataset.title.localeCompare(b.dataset.title) || a.dataset.index - b.dataset.index; },
        featured: function (a, b) { return (b.dataset.available === 'true') - (a.dataset.available === 'true') || rank(a) - rank(b); }
      }[state.sort];
      list.sort(by);
      cards.forEach(function (cd) { cd.hidden = list.indexOf(cd) < 0; });
      list.forEach(function (cd, i) { grid.appendChild(cd); if (banner && i === after - 1) grid.appendChild(banner); });
      if (banner) { banner.hidden = list.length <= after; if (list.length <= after) grid.appendChild(banner); }
      if (countEl) countEl.textContent = list.length === 1 ? countEl.getAttribute('data-one') : countEl.getAttribute('data-many').replace('[count]', list.length);
      var filtered = state.style !== 'all' || state.colour !== null;
      $$('[data-fb-clear]', root).forEach(function (b) { if (!b.closest('[data-fb-empty]')) b.hidden = !filtered; });
      $('[data-fb-empty]', root).hidden = list.length > 0;
      $$('[data-fb-style]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-fb-style') === state.style); });
      $$('[data-fb-colour]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-fb-colour') === state.colour); });
    }
    root.addEventListener('click', function (e) {
      var s = e.target.closest('[data-fb-style]'); if (s) { state.style = s.getAttribute('data-fb-style'); apply(); return; }
      var k = e.target.closest('[data-fb-colour]'); if (k) { var v = k.getAttribute('data-fb-colour'); state.colour = state.colour === v ? null : v; apply(); return; }
      if (e.target.closest('[data-fb-clear]')) { state.style = 'all'; state.colour = null; apply(); }
    });
    var sel = $('[data-fb-sort]', root); sel && sel.addEventListener('change', function () { state.sort = sel.value; apply(); });
    // deep links: ?style=simona&colour=1
    try { var q = new URLSearchParams(location.search); if (q.get('style')) state.style = q.get('style'); if (q.get('colour')) state.colour = q.get('colour'); } catch (e) {}
    apply();
  }

  function init() { initHeader(); initCart(); initGeneric(); initPdp(); initCollection(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { init(); });
})();
